import { ErrorMonitoringService } from './ErrorMonitoring';

export class SentryMonitoringServerService implements ErrorMonitoringService {
  addCustomTag() {
    return Promise.resolve();
  }
  identify() {
    return Promise.resolve();
  }
  captureError() {
    return Promise.resolve();
  }
}
